export default __webpack_public_path__ + "static/media/rewodsingup.0db6b60d.png";